import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import { selectFetchingCredential } from 'store/Credentials/selectors';
import { showCredentialDetail } from 'store/Credentials/actions';
import Header from './components/Header';
import Info from './components/Info';
import {
  ResizerWrapper, DetailWrapper, Resizer,
  Transparency
} from 'Screens/Contextualization/Host/components/HostDetail/styled';
import { Wrapper, Content } from './styled';
import SpinnerComponent from 'Common/Components/SpinnerContainer';

const CredentialDetail = () => {
  const [showTransparency, setShowTransparency] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);
  const isFetchingCredential = useSelector(selectFetchingCredential);
  const dispatch = useDispatch();

  const handleClose = () => dispatch(showCredentialDetail(false));

  useModalShortcuts({ id: 'credential-detail', onCancel: handleClose, cancelLabel: 'Close' });

  const onScroll = () => {
    const scrollTop = get(ref, 'current.scrollTop', 0);
    if (scrollTop === 0) setShowTransparency(false);
    else setShowTransparency(true);
  };

  return (
      <>
        <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth }>
          <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
          <DetailWrapper>
            { isFetchingCredential
              ? <SpinnerComponent />
              : <>
                  <Header onClose={ handleClose } />
                  { showTransparency && <Transparency /> }
                  <Content tabRef={ ref } onScroll={ onScroll } showTransparency={ showTransparency }>
                    <Info />
                  </Content>
                </>
            }
          </DetailWrapper>
        </Wrapper>
      </>
  );
};

export default CredentialDetail;
